import { Link } from '@tanstack/react-router'

export function Footer() {
  return (
    <footer className="border-t border-white/[0.05] bg-[#050810] py-16">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12">
          <div className="space-y-4 text-center md:text-left">
            <Link
              to="/"
              className="text-2xl font-black tracking-tighter hover:opacity-80 transition-opacity"
            >
              <span className="brand-gradient-text">QuickClaw</span>
            </Link>
            <p className="text-xs text-[#5A6480] font-medium tracking-wide">
              Provision autonomous agentic engines in seconds.
            </p>
          </div>

          <div className="flex items-center gap-8">
            <a
              href="#features"
              className="text-xs font-black uppercase tracking-[0.2em] text-[#8892B0] hover:text-white transition-colors"
            >
              Capabilities
            </a>
            <Link
              to="/dashboard"
              className="text-xs font-black uppercase tracking-[0.2em] text-[#8892B0] hover:text-white transition-colors"
            >
              Dashboard
            </Link>
            <a
              href="#"
              className="text-xs font-black uppercase tracking-[0.2em] text-[#8892B0] hover:text-white transition-colors"
            >
              GCP_Nodes
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/[0.03] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#5A6480]">
            ESTB_SEQUENCE::{new Date().getFullYear()} QUICKCLAW_CORE
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-[10px] font-black uppercase tracking-[0.2em] text-[#5A6480] hover:text-white"
            >
              Privacy_Protocol
            </a>
            <a
              href="#"
              className="text-[10px] font-black uppercase tracking-[0.2em] text-[#5A6480] hover:text-white"
            >
              Terms_v1.2
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
